import { Component, Input } from '@angular/core';
import { Parameter } from 'src/app/data/type/parameter';
import { ParameterService } from 'src/app/service/parameter.service';

@Component({
  selector: 'app-a05-custom-cta',
  templateUrl: './a05-custom-cta.component.html',
  styleUrls: ['./a05-custom-cta.component.scss'],
})
export class A05CustomCtaComponent {
  @Input() customClass?: string;

  public customCTAHref = this.parameterService.getParam(Parameter['custom-cta-href']);
  public customCTALabel = this.parameterService.getParam(Parameter['custom-cta-label']);
  public customCTAAriaLabel =
    this.parameterService.getParam(Parameter['custom-cta-aria-label']) ||
    this.parameterService.getParam(Parameter['custom-cta-label']);

  constructor(private parameterService: ParameterService) {}
}
